import React, {Component } from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { Route } from 'containers'
import * as Containers from 'containers'
import { TokenActions } from 'actionsets'
import { throttle } from 'utils'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import StyleSheet from 'styles'
import { Authorization } from 'utils'

export class Routes extends Component{

  static activityEventTypes = ['mousemove', 'click', 'keydown', 'resize']

  constructor(props){
    super(props)
    TokenActions.bindActions(this, 'token')
    this.registerActivity = throttle(this.actions.token.registerActivity)
    this.registerActivity()
  }

  monitorActivity = container => {
    if(this.container){
      Routes.activityEventTypes.forEach(type => this.container.removeEventListener(type, this.registerActivity))
    }
    this.container = container
    if(this.container){
      Routes.activityEventTypes.forEach(type => this.container.addEventListener(type, this.registerActivity))
    }
  }

  get defaultRedirect(){
    switch(true){
      case Authorization.prompt2fa:           { return '/enable_2fa'}
      case Authorization.admin:               { return '/deal_sheets_admin' }
      case !Authorization.tncsAgreed:         { return '/tncs' }
      case Authorization.registeredIssuer:    { return '/deal_sheets/list/mine' }
      case Authorization.registeredInvestor:  { return '/dashboard' }
      case Authorization.draftIssuer:         { return `/issuer/${Authorization.user.id}/edit` }
      case Authorization.draftInvestor:       { return `/investor/${Authorization.user.id}/edit` }
      default:                                { return `/no_account` }
    }
  }

  redirectToPermittedViewers = props =>
    <Redirect to={`/deal_sheets/${props.match.params.id}/viewers/permitted`}/>

  redirectToDealSheet = props =>
    (Authorization.admin || Authorization.issuer) ?
      <Redirect to={`/deal_sheets/${props.match.params.id}/summary/`}/> :
      <Redirect to={`/deal_sheets/${props.match.params.id}/view/`}/>

  redirectToDealSheetNew = props =>
    <Redirect to={`/deal_sheets/new/deal_info`}/>

  redirectToRoot = () =>
    <Redirect to={this.defaultRedirect}/>

  redirectToDraftDealSheets = () =>
    <Redirect to={`deal_sheets/list/draft`}/>

  render = () =>
    <Route>
      <div className={styles.container} ref={this.monitorActivity}>
        <Switch>
          <Route exact path="/audit_logs"                                         component={Containers.AuditLogs.List}/>
          <Route exact path="/dashboard"                                          component={Containers.Dashboard}/>
          <Route exact path="/users"                                              component={Containers.User.List} requires={Authorization.admin} />
          <Route exact path="/users/new"                                          component={Containers.User.Invite} requires={Authorization.admin} />
          <Route exact path="/users/:id/edit"                                     component={Containers.Profile} requires={Authorization.admin} />
          <Route exact path="/profile"                                            component={Containers.Profile}/>
          <Route exact path="/tokens/sign_in"                                     component={Containers.Token.SignIn}/>
          <Route exact path="/tokens/sign_up"                                     component={Containers.Token.SignUp}/>
          <Route exact path="/tokens/forgot"                                      component={Containers.Token.Forgot}/>
          <Route exact path="/tokens/reset"                                       component={Containers.Token.Reset}/>
          <Route exact path="/tokens/confirm"                                     component={Containers.Token.Confirm}/>
          <Route exact path="/tokens/accept_invitation"                           component={Containers.Token.AcceptInvitation}/>
          <Route exact path="/tokens/enable_2fa"                                  component={Containers.Token.Enable2fa}/>
          <Route exact path="/:accountType(issuer|investor)/:id/edit"             component={Containers.Account.AccountInfo}/>
          <Route exact path="/not_found"                                          component={Containers.NotFound} />
          <Route exact path="/kyc"                                                component={Containers.Kyc} />
          <Route exact path="/timed_out"                                          component={Containers.TimedOut} />
          <Route exact path="/error_occurred"                                     component={Containers.ErrorOccurred} />
          <Route exact path="/:accountType(issuer|investor)/registration_complete" component={Containers.RegistrationComplete} />
          <Route exact path="/under_construction"                                 component={Containers.UnderConstruction} />
          <Route exact path="/inactive"                                           component={Containers.Inactive} />
          <Route exact path="/unauthorized"                                       component={Containers.Unauthorized} />
          <Route exact path="/enable_2fa"                                         component={Containers.Enable2fa} />
          <Route exact path="/no_account"                                         component={Containers.NoAccount} />
          <Route exact path="/tncs"                                               component={Containers.User.Tncs} />
          <Route exact path="/documents/edit"                                     component={Containers.Document.Edit} requires={Authorization.admin}/>
          <Route exact path="/allocations"                                        component={Containers.DealSheet.AllAllocations} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/new"                                    component={this.redirectToDealSheetNew} requires={Authorization.admin || Authorization.issuer}/>
          <Route exact path="/deal_sheets/new/:tab(summary|deal_info|allocations_tab|nominations|investors|admin)/:step?"
                                                                                  component={Containers.DealSheet.Management} requires={Authorization.admin || Authorization.issuer} />
          <Route exact path="/deal_sheets/featured"                               component={Containers.DealSheet.FeaturedListingsForm} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/:id"                                    component={this.redirectToDealSheet} requires={Authorization.registered}/>
          <Route exact path="/deal_sheets/:id/:tab(summary|deal_info|allocations_tab|nominations|investors|admin)/:step?"
                                                                                  component={Containers.DealSheet.Management} requires={Authorization.admin || Authorization.issuer} />
          <Route exact path="/deal_sheets/:id/viewers"                            component={this.redirectToPermittedViewers} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/:id/viewers/:tab(permitted|restricted)" component={Containers.DealSheet.Viewers} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/:id/allocations/new"                    component={Containers.Allocations.Form} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/:id/allocations/edit"                   component={Containers.Allocations.Form} requires={Authorization.admin} />
          <Route exact path="/deal_sheets/:id/allocations/:allocationId?"         component={Containers.Allocations.Allocation} requires={Authorization.approved}/>
          <Route exact path="/deal_sheets/:id/view"                               component={Containers.DealSheet.Show} requires={Authorization.registered} />
          <Route exact path="/deal_sheets/:id/:tab(funds_destination)"            component={Containers.DealSheet.Show} requires={Authorization.admin} />
          <Route exact path="/deal_sheets"                                        component={this.redirectToDraftDealSheets} requires={Authorization.admin || Authorization.issuer}/>

          <Route exact path="/deal_sheets_admin"                                  component={Containers.DealSheet.AdminDealsList} requires={Authorization.admin}/>
          <Route exact path="/deal_sheets/list/:filter"                           component={Containers.DealSheet.Deals} requires={Authorization.registered} />

          <Route exact path="/notifications"                                      component={Containers.Notifications.List} />
          <Route exact path="/third_parties"                                      component={Containers.ThirdParties.List} requires={Authorization.admin}/>
          <Route exact path="/third_parties/new"                                  component={Containers.ThirdParties.Form} requires={Authorization.admin}/>
          <Route exact path="/third_parties/:id"                                  component={Containers.ThirdParties.Show} requires={Authorization.admin}/>
          <Route exact path="/third_parties/:id/edit"                             component={Containers.ThirdParties.Form} requires={Authorization.admin}/>
          <Route exact path="/countries"                                          component={Containers.Countries.List} requires={Authorization.admin}/>
          <Route exact path="/countries/new"                                      component={Containers.Countries.Form} requires={Authorization.admin}/>
          <Route exact path="/countries/:id"                                      component={Containers.Countries.Show} requires={Authorization.admin}/>
          <Route exact path="/countries/:id/edit"                                 component={Containers.Countries.Form} requires={Authorization.admin}/>
          <Route exact path="/country_groups"                                     component={Containers.CountryGroups.List} requires={Authorization.admin}/>
          <Route exact path="/country_groups/new"                                 component={Containers.CountryGroups.Form} requires={Authorization.admin}/>
          <Route exact path="/country_groups/:id"                                 component={Containers.CountryGroups.Show} requires={Authorization.admin}/>
          <Route exact path="/country_groups/:id/edit"                            component={Containers.CountryGroups.Form} requires={Authorization.admin}/>
          <Route exact path="/"                                                   component={this.redirectToRoot}/>
          <Route                                                                  component={Containers.NotFound} />
        </Switch>
      </div>
    </Route>
}

const styles = StyleSheet({
  container: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex'
  }
})

export default withRouter(connect(({tokens}) => tokens)(Routes))